import type { ImpressumStrings } from "../../types";

export const impressum: ImpressumStrings = {
  title: "Impressum",
  sections: [
    {
      title: "Información conforme al § 5 DDG",
      paragraphs: [
        { pre: true, nodes: ["0-AI UG (haftungsbeschränkt)\nNeckartalstraße 127\n70376 Stuttgart\nAlemania"] },
      ],
    },
    {
      title: "Representada por",
      paragraphs: [
        { pre: true, nodes: ["Administradores:\nPaul Willi Patrick Horn\nAnton Leo Rudolf Horn"] },
      ],
    },
    {
      title: "Contacto",
      paragraphs: [{ nodes: ["Correo electrónico: contact@cero-ai.com"] }],
    },
    {
      title: "Inscripción en el registro",
      paragraphs: [
        { pre: true, nodes: ["Inscripción en el registro mercantil\nTribunal de registro: Amtsgericht Stuttgart\nNúmero de registro: En tramitación"] },
      ],
    },
    {
      title: "Número de IVA",
      paragraphs: [
        { pre: true, nodes: ["Número de identificación fiscal a efectos del IVA conforme al § 27a UStG:\nSolicitado"] },
      ],
    },
    {
      title: "Responsable del contenido conforme al § 18 (2) MStV",
      paragraphs: [
        { pre: true, nodes: ["Paul Willi Patrick Horn\nNeckartalstraße 127\n70376 Stuttgart"] },
      ],
    },
    {
      title: "Resolución de litigios",
      paragraphs: [
        {
          nodes: [
            "La Comisión Europea proporciona una plataforma de resolución de litigios en línea (ODR): ",
            { link: "ec.europa.eu/consumers/odr", href: "https://ec.europa.eu/consumers/odr/" },
          ],
        },
        {
          nodes: [
            "No estamos dispuestos ni obligados a participar en procedimientos de resolución de litigios ante una junta de arbitraje de consumo.",
          ],
        },
      ],
    },
  ],
};
